import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getArticles } from "../services/api";
import Sidebar  from "../components/Sidebar";
import PageHero from "../components/PageHero";

function formatDate(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleDateString("es-PE", {
    year: "numeric", month: "short", day: "numeric",
  });
}

export default function Articles() {
  const [articles, setArticles] = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [error,    setError]    = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    getArticles()
      .then(setArticles)
      .catch(() => setError("No se pudieron cargar los artículos."))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="page">
      <PageHero
        section="articulos"
        title="Artículos"
        backBtn={{ label: "Inicio", onClick: () => navigate("/") }}
      />

      <div className="two-col">
        <main>
          {error && <p style={{ color: "#c0392b" }}>{error}</p>}

          {loading && (
            <div style={{ display: "flex", flexDirection: "column", gap: ".8rem" }}>
              {[1, 2, 3].map((n) => (
                <div className="skel" key={n} style={{ display: "flex", gap: ".9rem", padding: "1rem" }}>
                  <div className="skel-line" style={{ width: 44, height: 44, borderRadius: 8, flexShrink: 0 }} />
                  <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 6 }}>
                    <div className="skel-line" style={{ width: "60%", height: 13 }} />
                    <div className="skel-line" style={{ width: "100%", height: 11 }} />
                    <div className="skel-line" style={{ width: "40%", height: 10 }} />
                  </div>
                </div>
              ))}
            </div>
          )}

          {!loading && !error && articles.length === 0 && (
            <div className="card">
              <p style={{ color: "var(--text-muted)", fontSize: "0.875rem" }}>
                No hay artículos publicados aún.
              </p>
            </div>
          )}

          <div style={{ display: "flex", flexDirection: "column", gap: ".8rem" }}>
            {!loading && articles.map((a) => (
              <div
                key={a.id}
                onClick={() => navigate(`/articulos/${a.id}`)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => e.key === "Enter" && navigate(`/articulos/${a.id}`)}
                style={{
                  background: "var(--white)",
                  border: "0.5px solid var(--border)",
                  borderRadius: "var(--card-radius)",
                  padding: "1rem 1.2rem",
                  display: "flex",
                  gap: "1rem",
                  cursor: "pointer",
                  transition: "box-shadow .15s",
                }}
                onMouseEnter={(e) => e.currentTarget.style.boxShadow = "0 3px 12px rgba(0,0,0,.08)"}
                onMouseLeave={(e) => e.currentTarget.style.boxShadow = ""}
              >
                <div style={{
                  width: 48, height: 48, borderRadius: 8,
                  background: "var(--teal-light)",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontSize: "1.4rem", flexShrink: 0,
                }}>
                  {a.pdf_url ? "📄" : "📝"}
                </div>

                <div style={{ flex: 1, minWidth: 0 }}>
                  <h3 style={{
                    fontFamily: "var(--font-display)", fontWeight: 700,
                    fontSize: "0.9rem", color: "var(--charcoal)",
                    marginBottom: ".3rem", textTransform: "uppercase",
                  }}>
                    {a.title}
                  </h3>
                  {a.description && (
                    <p style={{
                      fontSize: "0.8rem", color: "var(--text-muted)", lineHeight: 1.55,
                      overflow: "hidden", display: "-webkit-box",
                      WebkitLineClamp: 2, WebkitBoxOrient: "vertical",
                    }}>
                      {a.description}
                    </p>
                  )}
                  <div style={{ display: "flex", gap: "1rem", marginTop: ".4rem", alignItems: "center", flexWrap: "wrap" }}>
                    <span style={{ fontSize: "0.72rem", color: "var(--text-light)" }}>
                      {formatDate(a.created_at)}
                    </span>
                    {a.pdf_url && (
                      <span style={{
                        fontSize: "0.68rem", fontFamily: "var(--font-display)", fontWeight: 700,
                        background: "#fdf3dc", color: "#a07800",
                        padding: "2px 8px", borderRadius: 20, letterSpacing: .3,
                      }}>
                        PDF adjunto
                      </span>
                    )}
                  </div>
                </div>

                <span style={{ color: "var(--teal)", fontSize: "1rem", alignSelf: "center", flexShrink: 0 }}>→</span>
              </div>
            ))}
          </div>
        </main>

        <Sidebar />
      </div>
    </div>
  );
}